import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, reactive } from 'vue';
import { GChart } from 'vue-google-charts/legacy'
import Skeleton from './loaders/Skeleton.vue'

type ChartDataItem = string | number;

type ChartData = ChartDataItem[]


export default /*#__PURE__*/_defineComponent({
  __name: 'DonutChart',
  props: {
    chartData: null,
    colors: null,
    of: null,
    highlight: null,
    loading: { type: Boolean }
  },
  setup(__props: any, { emit }: { emit: ({
  chartReady: () => void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  chartData: ChartData[],
  colors: Array<string>,
  of?: string,
  highlight?: string,
  loading?: boolean,
};





const donutChart = ref(null);

const chart = ref<unknown>(null);
const hoverLegendItems = ref<number[]>([]);
const data = computed(() => [['', ''] as ChartData].concat(props.chartData));
const accumulatoryLength = computed(() => data.value.slice(1).reduce((accumulator: number, current: ChartData) => accumulator + (current[1] as number), 0));
const highlightLength = computed(() => {
  const item = data.value.find(item => item[0] as string === props.highlight as string);
  return item ? item[1] || 0 : 0;
});
const options = reactive({
  width: 150,
  height: 150,
  pieHole: 0.6,
  colors: computed(() => props.colors),
  tooltip: {
    isHtml: true,
    position: 'bottom',
    text: 'value'
  },
  legend: {
    position: 'none',
    alignment: 'center',
    maxLines: 1
  }
})

function onChartReady(eventChart: unknown, google: unknown) {
  chart.value = eventChart;
  google.visualization.events.addListener(eventChart, 'onmouseover', function(e: unknown) {
    hoverLegendItems.value = hoverLegendItems.value.concat(e.row);
  });

  google.visualization.events.addListener(eventChart, 'onmouseout', function(e: unknown) {
    hoverLegendItems.value = hoverLegendItems.value.filter(item => item !== e.row);
  });

  google.visualization.events.addListener(eventChart, 'select', selectHandler);
  emit('chartReady');
}

function selectHandler() {  
  chart.value.setSelection([]);
}

function hover(index: number) {
  // google has no setter for hover, only for selection (which is click)
  // so we're applying the hover style but for selection.
  if(accumulatoryLength.value && chart) {
    chart.value.setSelection([{ column: null, row: index }]);
    const element = donutChart.value?.$el?.querySelector('svg g path:not(:first-child), ellipse');
    if (element) {
      element.style.strokeWidth = '10px';
      element.style.strokeOpacity = '0.35';
      element.style.transform = 'scale(96%) translate(2%, 2%)';
    }
  }
}

function leave() {
  if(accumulatoryLength.value && chart) {
    chart.value.setSelection([]);
  }
}


return { __sfc: true,props, emit, donutChart, chart, hoverLegendItems, data, accumulatoryLength, highlightLength, options, onChartReady, selectHandler, hover, leave, GChart, Skeleton }
}

})